import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { RAY_WHITE_META } from "./meta.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./offices.ts";
export * from "./runtime.ts";

// Office sites use Cloudflare/Akamai-ish protections sporadically. Route
// Bright Data first so the cascade isn't 429'd before reaching the
// SSR listings.
export const RAY_WHITE_ADAPTER = defineSoldOnlyAdapter(RAY_WHITE_META, buildSearchUrl, {
  brightdataDiscoveryFirst: true,
});
